
import { Vue, Component } from 'vue-property-decorator'
import AboutUsContent from '@/components/layout/AboutUsContent.vue'
import VerticalHeading from '@/components/typography/VerticalHeading.vue'
import SignUpBanner from '@/components/layout/SignUpBanner.vue'
import { Config } from 'tradingmate-modules/src/environment'

@Component({
  components: {
    AboutUsContent,
    VerticalHeading,
    SignUpBanner
  }
})

export default class AboutUs extends Vue {
  CtaClicked (): void {
    window.open(Config.WebsiteUrls.Console + '/account/register', '_self')
  }

  PackagesClicked (): void {
    window.open('/about/pricing', '_self')
  }
}
